import { InAppMessageBridge } from "./InAppMessageBridge"
import { WebIframeInAppMessageBridge } from "./WebIframeInAppMessageBridge"
import { BrowserHackleClient } from "../../../../hackle/HackleClientImpl.browser"
import { InAppMessageUi } from "../InAppMessageUi"

export interface InAppMessageBridgeFactory {
  create(ui: InAppMessageUi): InAppMessageBridge
}

interface Supplier<T> {
  (): T
}

export class InAppMessageBridgeFactoryFactory {
  static createWebIframe(hackleClientSupplier: Supplier<BrowserHackleClient>): InAppMessageBridgeFactory {
    return new WebIframeInAppMessageBridgeFactory(hackleClientSupplier)
  }
}

class WebIframeInAppMessageBridgeFactory implements InAppMessageBridgeFactory {
  constructor(private readonly hackleClientSupplier: Supplier<BrowserHackleClient>) {}

  create(ui: InAppMessageUi): InAppMessageBridge {
    return new WebIframeInAppMessageBridge(this.hackleClientSupplier(), ui)
  }
}
